module PortalLibs.Client.Notifications


open Elmish.Toastr
open Fable.Import
open PortalLibs.Shared.Notifications
open Thoth.Elmish
open System
open Elmish

let success str =
  Toastr.message $"%s{str} successfully"
  |> Toastr.position ToastPosition.TopCenter
  |> Toastr.timeout 1000
  |> Toastr.success

let error str =
  Toastr.message str
  |> Toastr.position BottomFullWidth
  |> Toastr.showCloseButton
  |> Toastr.error

let warning str =
  Toastr.message str
  |> Toastr.position BottomFullWidth
  |> Toastr.showCloseButton
  |> Toastr.timeout 10000
  |> Toastr.warning

let info str =
  Toastr.message str
  |> Toastr.position ToastPosition.TopCenter
  |> Toastr.timeout 5000
  |> Toastr.info

let showNotif msg =
  match msg with
  | Success str -> success str
  | Error str -> error str
  | Exception e ->
      Browser.Dom.console.error e
      error $"Unhandled exception: {e.Message}"
  | Warning str -> warning str
  | Info str -> info str

let debounce debouncer notifMsg msg =
  match msg with
  | Success _ -> Debouncer.bounce (TimeSpan.FromSeconds 2.5) $"%A{msg}" (notifMsg msg) debouncer
  | Error _ | Exception _ -> Debouncer.bounce (TimeSpan.FromSeconds 0.1) $"%A{msg}" (notifMsg msg) debouncer
  | Warning _ -> Debouncer.bounce (TimeSpan.FromSeconds 0.1) $"%A{msg}" (notifMsg msg) debouncer
  | Info _ -> Debouncer.bounce (TimeSpan.FromSeconds 2.0) $"%A{msg}" (notifMsg msg) debouncer